import { DateTime } from "luxon";
import {
  ZUS_INSTRUCTIONAL_VIDEOS_MIN_AGE,
  ZUS_INSTRUCTIONAL_VIDEOS_MAX_AGE,
  ZUS_INSTRUCTIONAL_VIDEOS_STUDENT_MAX_AGE,
} from "@/types/questionnaire";

export function isInstructionalVideosRequired(
  birthDate: string,
  isStudent: boolean,
  isEmployed: boolean,
): boolean {
  const birthDateTime = DateTime.fromISO(birthDate);
  const now = DateTime.now();
  const age = now.diff(birthDateTime, "years").years;

  if (
    age < ZUS_INSTRUCTIONAL_VIDEOS_MIN_AGE ||
    age > ZUS_INSTRUCTIONAL_VIDEOS_MAX_AGE ||
    (isStudent &&
      age >= ZUS_INSTRUCTIONAL_VIDEOS_MIN_AGE &&
      age <= ZUS_INSTRUCTIONAL_VIDEOS_STUDENT_MAX_AGE) ||
    isEmployed
  ) {
    return false;
  }

  return true;
}
